<template>
  <el-dialog
    id="unableModal"
    :title="$t('actionPlan.unableToPublish')"
    :visible.sync="showLocal"
    :width="dialogWidth"
  >
    {{ $t('actionPlan.makeSureRequirement.title') }}:

    <ol>
      <li
        v-for="i in 3"
        :key="`desc_${i}`"
      >
        {{ $t(`actionPlan.makeSureRequirement.list_${i}`) }}
      </li>
    </ol>

    <div class="dialogAction">
      <el-button
        type="primary"
        round
        @click="showLocal = false"
      >
        Confirm
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';

export default {
  name: 'UnableDialog',

  mixins: [dialog],
};
</script>

<style lang="scss" scoped>
  #unableModal {
    .dialogAction {
      text-align: center;
      padding-top: 18px;
    }
  }
</style>
